var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.972656,
    y: 0.0273438,
    width: 32,
    height: 32,
    fill: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 13H10.5V22H24.5V13Z",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 18.75C18.1904 18.75 18.75 18.1904 18.75 17.5C18.75 16.8096 18.1904 16.25 17.5 16.25C16.8096 16.25 16.25 16.8096 16.25 17.5C16.25 18.1904 16.8096 18.75 17.5 18.75Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 13V9C21.5 7.93913 21.0786 6.92172 20.3284 6.17157C19.5783 5.42143 18.5609 5 17.5 5C16.4391 5 15.4217 5.42143 14.6716 6.17157C13.9214 6.92172 13.5 7.93913 13.5 9V13",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 28C13.3284 28 14 27.3284 14 26.5C14 25.6716 13.3284 25 12.5 25C11.6716 25 11 25.6716 11 26.5C11 27.3284 11.6716 28 12.5 28Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 28C18.3284 28 19 27.3284 19 26.5C19 25.6716 18.3284 25 17.5 25C16.6716 25 16 25.6716 16 26.5C16 27.3284 16.6716 28 17.5 28Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 28C23.3284 28 24 27.3284 24 26.5C24 25.6716 23.3284 25 22.5 25C21.6716 25 21 25.6716 21 26.5C21 27.3284 21.6716 28 22.5 28Z",
    fill: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 28C28.3284 28 29 27.3284 29 26.5C29 25.6716 28.3284 25 27.5 25C26.6716 25 26 25.6716 26 26.5C26 27.3284 26.6716 28 27.5 28Z",
    fill: "#333333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 28C8.32843 28 9 27.3284 9 26.5C9 25.6716 8.32843 25 7.5 25C6.67157 25 6 25.6716 6 26.5C6 27.3284 6.67157 28 7.5 28Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/Password.b0229a26c4ccc141c614b07164cfe26f.svg";
export { ForwardRef as ReactComponent };